<template>
  <el-form :model="formData" class="search-bar-wrapper">
    <label-input
      class="control"
      label="药师名称"
      placeholder="请输入药师名称"
      width="230px"
      v-model="formData.name"
      v-permission="'a'"
      :input-attr="{ maxlength: 10 }"
    />
    <el-select class="control" style="width: 120px" v-model="formData.type" clearable="" placeholder="打卡类型">
      <el-option v-for="item in punchOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <el-date-picker
      class="zy-date-picker"
      v-model="formData.date"
      type="daterange"
      range-separator="-"
      start-placeholder="开始时间"
      end-placeholder="结束时间"
      value-format="yyyy-MM-dd HH:mm:ss"
      :default-time="['00:00:00', '23:59:59']"
      clearable
    ></el-date-picker>
    <el-button class="search-btn" @click="search">查询</el-button>
  </el-form>
</template>

<script>
import labelInput from '@/components/global/form/labelInput';

export default {
  name: 'searchBar',
  props: ['searchParam'],
  components: {
    labelInput
  },
  data() {
    return {
      punchOptions: [
        {
          label: '上班',
          value: '1'
        },
        {
          label: '下班',
          value: '2'
        },
        {
          label: '下班缺卡',
          value: '3'
        },
        {
          label: '上班缺卡',
          value: '4'
        }
      ],
      formData: {
        name: '',
        type: undefined,
        date: []
      }
    };
  },
  methods: {
    search() {
      const {
        formData: { name, type, date }
      } = this;
      const [startTime, endTime] = date || [];
      this.$emit('search', {
        userName: name,
        type: type || undefined,
        startTime,
        endTime
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.search-bar-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;

  // .control {
  //   margin-right: 16px;
  //   margin-bottom: 10px;
  // }

  .zy-date-picker {
    margin-right: 16px;
    margin-bottom: 10px;
  }

  .search-btn {
    margin-bottom: 10px;
    height: 40px !important;
    width: 80px !important;
    color: #1e8dff !important;
    background: #ffffff !important;
    border: 1px solid #1e8dff !important;
    &:hover {
      background: rgba(68, 184, 91, 0.1) !important;
    }
  }
}
</style>
